import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

// Minimal top bar for the focused booking journey: brand logo only,
// plus a single back action. No site navigation on purpose.
// The logo is an escape hatch to the homepage, but confirms first so a
// stray click can't discard a part-filled booking.
const JourneyBar = ({ onBack, backLabel = 'Back' }) => {
  const [confirmExit, setConfirmExit] = useState(false);

  return (
    <div className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-slate-200">
      <div className="max-w-5xl mx-auto flex items-center justify-between px-4 sm:px-6 py-3">
        <button
          type="button"
          onClick={() => setConfirmExit(true)}
          aria-label="Leave and return to homepage"
          className="rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F17221]"
        >
          <img
            src="/assets/images/xfas-logo.png"
            alt="XFas Logistics"
            className="h-9 sm:h-10 w-auto transition-opacity hover:opacity-80"
          />
        </button>

        {onBack ? (
          <Button
            variant="ghost"
            onClick={onBack}
            className="text-slate-600 hover:text-[#0A1128] font-semibold"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {backLabel}
          </Button>
        ) : null}
      </div>

      <AlertDialog open={confirmExit} onOpenChange={setConfirmExit}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Leave this booking?</AlertDialogTitle>
            <AlertDialogDescription>
              You&apos;ll go back to the homepage and the details you&apos;ve entered
              so far will be lost. Your parcel won&apos;t be booked.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Stay here</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                window.location.href = '/';
              }}
              className="bg-[#F17221] hover:bg-[#d9661d] text-white"
            >
              Leave
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default JourneyBar;
